import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
import { FlowSteps } from './FlowSteps';
import { CHECKOUT_URL } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const systemGives = ['Visual coaching progressions', 'Ready-to-use drills', 'Technical sequences', 'Reaction systems', 'Coaching cues', 'Common-error corrections', 'Decision maps', 'Controlled resistance progressions', 'Complete session structures'];
export function SystemIntro() {
  return <section className="py-24 px-4 bg-zinc-950" data-id="element-258" data-mp="1fl45avzula9e">
      <div className="max-w-5xl mx-auto" data-id="element-259" data-mp="1khclmcps79i5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center max-w-3xl mx-auto" data-id="element-260" data-mp="1kkqm1fevx8my">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-white" data-id="element-261" data-mp="30v2o5f195ppo">
            From random drills to a complete MMA coaching system
          </h2>
          <p className="text-xl text-zinc-300 mb-3" data-id="element-262" data-mp="11gsfk9wyj7ug">
            MMA Coach Ready was created to give coaches structure without taking away their coaching
            judgment.
          </p>
          <p className="text-lg text-zinc-400 mb-6" data-id="element-263" data-mp="rje1ui2f4x5u">Instead of beginning every session from zero:</p>
          <FlowSteps steps={['Open', 'Choose', 'See', 'Coach']} size="lg" data-id="element-264" data-mp="mkb8huvswfdp" />
        </motion.div>

        <div className="mt-14 border-t border-zinc-800 pt-10" data-id="element-265" data-mp="hsjbp2m1xdf4">
          <h3 className="text-xl font-extrabold uppercase text-white mb-6 text-center" data-id="element-266" data-mp="hqyltqaominl">
            The system gives you:
          </h3>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 max-w-4xl mx-auto" data-id="element-267" data-mp="8swktaqy7q0b">
            {systemGives.map(item => <li key={item} className="flex items-start gap-3" data-id="element-268" data-mp="3ss17buquf5v">
                <CheckCircle2 size={18} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-269" data-mp="3uzbdkvg8ad6a" />
                <span className="text-zinc-300" data-id="element-270" data-mp="3laxop6k3iej6">{item}</span>
              </li>)}
          </ul>
          <p className="text-lg text-zinc-400 text-center max-w-3xl mx-auto mt-10" data-id="element-271" data-mp="3qc3m3hopapz1">
            And because the system is designed to be 100% visual, you can understand the setup and
            progression quickly instead of reading pages of theory before teaching.
          </p>
          <p className="text-2xl font-display font-black uppercase text-amber-400 text-center mt-4" data-id="element-272" data-mp="7wsxyfvk4qjd">
            Open the page and use it.
          </p>
        </div>

        <div className="mt-14 bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 text-center" data-id="element-273" data-mp="cy098owws7us">
          <h3 className="text-2xl md:text-3xl font-black uppercase text-white mb-2" data-id="element-274" data-mp="36claxzk98y2">
            Stop planning from scratch
          </h3>
          <p className="text-lg text-zinc-300 mb-8" data-id="element-275" data-mp="quvstbasdhp3">
            Open the system. Choose the session. Start coaching.
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8" data-id="element-276" data-mp="vnydsv1hzito">
            Get MMA Coach Ready Now
          </Button>
        </div>
      </div>
    </section>;
}